<template>
    <div>
        <div class="d-flex flex-row-reverse">
            <button class="btn btn-outline-success"
                :disabled="!permissions.find(e => e.permission_name == 'Create Coupons')"
                @click.prevent="addNewCoupon">Add Coupon</button>
        </div>
        <div class="card my-3 p-3" style="height: 65vh;"
            v-if="add_or_edit_coupon && permissions.find(e => e.permission_name == 'Create Coupons')">
            <div class="text-center">
                <h3>{{ edit_id ? 'Edit Coupon' : 'Add Coupon' }}</h3>
            </div>
            <div class="d-flex flex-row flex-wrap">
                <div class="col-6">
                    <label for="coupon_text" class="ml-2">Coupon Text:</label>
                    <input type="text" v-model="add_edit_coupon_template.coupon" class="form-control" required>
                </div>
                <div class="col-6">
                    <label for="coupon_text" class="ml-2">Coupon Discount (%):</label>
                    <input type="text" v-model="add_edit_coupon_template.discount_percentage" class="form-control"
                        required>
                </div>
                <div class="col-6 py-3">
                    <label for="coupon_description" class="ml-2">Coupon Description:</label>
                    <input type="text" v-model="add_edit_coupon_template.coupon_description" class="form-control"
                        required>
                </div>
                <div class="col-6 py-3">
                    <label for="birthday">Select Categories</label>
                    <MssSelect multiple type="select" v-model="selected_category" :options="category_list"
                        label="category_name" placeholder="Category"></MssSelect>
                </div>
                <div class="col-6 py-3">
                    <label for="coupon_text" class="ml-2">Coupon Max Discount (₹):</label>
                    <input type="text" v-model="add_edit_coupon_template.max_discount" class="form-control" required>
                </div>
                <div class="col-6 py-3">
                    <label for="coupon_text" class="ml-2">Coupon Max Usage (Number):</label>
                    <input type="text" v-model="add_edit_coupon_template.max_usage" class="form-control" required>
                </div>
                <div class="col-6 py-3">
                    <label for="coupon_text" class="ml-2">Coupon Min Price (₹):</label>
                    <input type="text" v-model="add_edit_coupon_template.minimum_price" class="form-control" required>
                </div>
                <div class="col-6 py-3">
                    <label for="coupon_text" class="ml-2">Used By Date (DD/MM/YYYY):</label>
                    <input type="date" v-model="add_edit_coupon_template.use_by_date" class="form-control" required>
                </div>
                <div class="col-12 py-3 text-center">
                    <button :class="edit_id ? 'btn btn-warning' : 'btn btn-success'" @click.prevent="add_coupon">
                        <i v-if="edit_id" class="fa fa-pencil pr-2"></i>
                        <i v-if="!edit_id" class="fa fa-plus pr-2"></i>
                        <span>{{ edit_id ? 'EDIT' : 'ADD' }}</span>
                    </button>
                    <button class="btn btn-danger ml-2" @click.prevent="closeAddCoupon"><i
                            class="fa fa-times pr-2"></i>CLOSE</button>
                </div>
            </div>
        </div>
        <div class="card my-3 p-3" style="height: 65vh; width: 100%; overflow-x: scroll;">
            <div
                :style="!permissions.find(e => e.permission_name == 'View Coupons') ? 'filter: blur(4px); pointer-events: none;' : ''">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th class="text-center" v-for="(heading, index) in table_heading" :key="index">
                                {{ heading }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(coupon, ind) in coupons_list" :key="ind">
                            <td class="text-center">{{ ind + 1 }}</td>
                            <td class="text-center">{{ coupon.coupon }}</td>
                            <td class="text-center" style="
                                display: flex;
                                height: 100%;
                                flex-direction: column;
                                gap: 3px;
                            ">
                                <template v-if="coupon.categories.length > 0">
                                    <div style="
                                        border: 1px solid gray;
                                        background-color: #ddfff4;
                                        border-radius: 1000px;
                                        padding: 2px 20px;
                                    " v-for="cal in coupon.categories">{{ cal.category_name }}</div>
                                </template>
                                <div style="
                                        border: 1px solid gray;
                                        background-color: #ddfff4;
                                        border-radius: 1000px;
                                        padding: 2px 20px;
                                    " v-else>All Products</div>
                            </td>
                            <td class="text-center">₹{{ coupon.max_discount }} <i class="fa fa-money text-success"></i>
                            </td>
                            <td class="text-center">{{ coupon.discount_percentage }} <i
                                    class="fa fa-percent text-warning"></i> </td>
                            <td class="text-center">{{ coupon.max_usage }} <i class="fa fa-user text-primary"></i> </td>
                            <td class="text-center">{{ coupon.use_by_date }} <i
                                    class="fa fa-calendar-check-o text-primary"></i></td>
                            <td class="text-center">₹{{ coupon.minimum_price }} <i class="fa fa-money text-success"></i>
                            </td>
                            <!-- <td  class="text-center">
                                <MssInput type="switch" @input="changeCouponStatus(coupon.id, coupon.status)" v-model="coupon.status" :placeholder="coupon.status ? 'Active' : 'Inactive'"></MssInput>
                            </td> -->
                            <td class="text-center" style="width: 100px;">
                                <button class="btn btn-warning btn-sm mr-1"
                                    :disabled="!permissions.find(e => e.permission_name == 'Edit Coupons')"
                                    @click.prevent="edit_coupon(coupon.id)"><i class="fa fa-pencil"></i></button>
                                <button class="btn btn-danger btn-sm"
                                    :disabled="!permissions.find(e => e.permission_name == 'Delete Coupons')"
                                    @click.prevent="deleteCoupon(coupon.id)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-top: -50%; z-index: 1000; width: max-content; margin-left: 38%;"
                v-if="!permissions.find(e => e.permission_name == 'View Coupons')">
                <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
                    permission.</span>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            add_or_edit_coupon: false,
            add_edit_coupon_template: {
                id: null,
                coupon: null,
                coupon_description: null,
                max_discount: null,
                discount_percentage: null,
                max_usage: null,
                use_by_date: null,
                minimum_price: null
            },
            edit_id: null,
            delete_id: null,
            coupons_list: [],
            table_heading: [
                "coupon",
                // "coupon_description",
                "Products",
                "max discount",
                "percentage",
                "max usage",
                "use by date",
                "minimum price",
                // "status",
                "action"
            ],
            debounce_timer: null,
            permissions: null,
            category_list: [],
            selected_category: []
        }
    },
    async mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'COUPONS' && e.has_permission == true)
        }
        await this.fetchCategory()
        await this.fetch_coupons()
    },
    methods: {
        async fetchCategory() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetchAllCategories',
                }
            })
            this.category_list = response.data.data
        },
        async deleteCoupon(id) {
            const ev = this
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                        data: {
                            type: 'delete_coupon',
                            id
                        }
                    }).then(function (response) {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 3000,
                            icon: response.data.status,
                            timerProgressBar: true,
                            title: response.data.msg
                        })
                        ev.fetch_coupons()
                    })
                }
            })
        },
        async changeCouponStatus(id, status) {
            clearTimeout(this.debounce_timer)
            this.debounce_timer = setTimeout(async () => {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        type: 'update_coupon_status',
                        id,
                        status: status
                    }
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
            }, 300);
        },
        async edit_coupon(id) {
            this.edit_id = id
            await this.fetchCategory()
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetch_coupons',
                    id
                }
            })
            this.add_edit_coupon_template = {
                id: id,
                coupon: response.data.coupons[0].coupon,
                coupon_description: response.data.coupons[0].coupon_description,
                max_discount: response.data.coupons[0].max_discount,
                discount_percentage: response.data.coupons[0].discount_percentage,
                max_usage: response.data.coupons[0].max_usage,
                use_by_date: response.data.coupons[0].use_by_date,
                minimum_price: response.data.coupons[0].minimum_price
            }
            this.selected_category = this.category_list.filter(e => response.data.coupons[0].categories.includes(e.id))
            this.add_or_edit_coupon = true
        },
        closeAddCoupon() {
            this.resetTemplate()
        },
        resetTemplate() {
            this.add_edit_coupon_template = {
                id: null,
                coupon: null,
                coupon_description: null,
                max_discount: null,
                discount_percentage: null,
                max_usage: null,
                use_by_date: null,
                minimum_price: null
            }
            this.selected_category = []
            this.edit_id = null
            this.add_or_edit_coupon = false
            this.fetch_coupons()
        },
        addNewCoupon() {
            this.add_or_edit_coupon = true
        },
        async fetch_coupons() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetch_coupons'
                }
            })
            const ev = this
            this.coupons_list = response.data.coupons.sort((a, b) => b.id - a.id).map(e => {
                return {
                    ...e,
                    categories: e.categories.map(el => ev.category_list.find(it => it.id == el))
                }
            })
        },
        async add_coupon() {
            let checked = false
            Object.keys(this.add_edit_coupon_template).forEach(e => {
                if (!this.add_edit_coupon_template[e] && e != 'id' && !checked) {
                    this.$toasted.global.error({
                        message: `${e} is a required field.`
                    })
                    checked = true
                }
            })
            if (checked) {
                return
            }
            let payload_data = {}
            if (!this.edit_id) {
                payload_data = {
                    type: 'create_coupon',
                    coupon_text: this.add_edit_coupon_template.coupon,
                    coupon_description: this.add_edit_coupon_template.coupon_description,
                    max_discount: this.add_edit_coupon_template.max_discount,
                    discount_percentage: this.add_edit_coupon_template.discount_percentage,
                    max_usage: this.add_edit_coupon_template.max_usage,
                    use_by_date: this.add_edit_coupon_template.use_by_date,
                    minimum_price: this.add_edit_coupon_template.minimum_price,
                    categories: this.selected_category.map(e => e.id)
                }
            } else {
                payload_data = {
                    type: 'update_coupon',
                    id: this.edit_id,
                    coupon_text: this.add_edit_coupon_template.coupon,
                    coupon_description: this.add_edit_coupon_template.coupon_description,
                    max_discount: this.add_edit_coupon_template.max_discount,
                    discount_percentage: this.add_edit_coupon_template.discount_percentage,
                    max_usage: this.add_edit_coupon_template.max_usage,
                    use_by_date: this.add_edit_coupon_template.use_by_date,
                    minimum_price: this.add_edit_coupon_template.minimum_price,
                    categories: this.selected_category.map(e => e.id)
                }
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: payload_data
            })
            console.log(response);
            this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                icon: response.data.status,
                timerProgressBar: true,
                title: `${this.edit_id ? "Coupon updated successfully." : "Coupon created successfully."}`
            })
            this.resetTemplate()
        },
    }
}
</script>